import {testPlaceholder} from "../../../../tests/test-data";

const onChange = (e) => {
  return e.target.value;
};
export const TextareaDefProps = {
  placeholder: testPlaceholder,
  value: '',
  onChange: onChange
};